import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { IntegrationParam } from '../models/integration-param.model';
import { Integration } from '../models/integration.model';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs-compat';
import { Card } from '../models/card.model';
import { IntegrationImage } from '../models/integration-image.model';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {

  integrations: Integration[] = [];
  currentIntegration: Integration = new Integration(0);

  integrationCards: Card[] = [];

  private currentIntegration$$: BehaviorSubject<Integration> = new BehaviorSubject(this.currentIntegration);

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router

  ) { }

  currentParam: IntegrationParam = new IntegrationParam(0);
  currentImage: IntegrationImage = new IntegrationImage(0);

  setCurrentIntegration(integration: Integration) {
    this.currentIntegration = integration;
    this.currentIntegration$$.next(this.currentIntegration);
  }

  integrationChanged(): Observable<any> {
    return this.currentIntegration$$.asObservable();
  }

  fetchCards() {
    const endpoint = environment.apiUrl + "/api/cards/integrations";

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.get<Card[]>(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  fetchIntegrations() {
    const endpoint = environment.apiUrl + "/api/integrations";

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  fetchIntegration(id: number) {
    const endpoint = environment.apiUrl + "/api/integrations/" + id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  updateParam(param: IntegrationParam) {
    const endpoint = environment.apiUrl + "/api/integration-params/" + param.id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.put(endpoint, param, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  updateImage(imageId: number, image: FormData) {
    const endpoint = environment.apiUrl + "/api/integration-images/" + imageId;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.put(endpoint, image, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  updateIntegration(integration: Integration) {
    const endpoint = environment.apiUrl + "/api/integrations/" + integration.id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.put(endpoint, integration, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  createIntegration(integration: Integration) {
    const endpoint = environment.apiUrl + "/api/integrations";

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.post(endpoint, integration, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  deleteParam(id: number) {
    const endpoint = environment.apiUrl + "/api/integration-params/" + id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.delete(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  deleteImage(id: number) {
    const endpoint = environment.apiUrl + "/api/integration-images/" + id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.delete(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  addParam(param: IntegrationParam) {
    const endpoint = environment.apiUrl + "/api/integration-params";

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.post(endpoint, param, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  addImage(payload: any) {
    const endpoint = environment.apiUrl + "/api/integration-images";

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.post(endpoint, payload, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }
}
